import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Collapse, Glyphicon } from "react-bootstrap";
import PivotTable from "./PivotTable";
import moment from "moment";
import { StoreContext } from "../../../contexts/StoreContext";

import "./TemplateRepresentation.scss";

const ConfirmButton = ({ onClick }) => (
  <div style={{ textAlign: "right", marginBottom: "3px" }}>
    <button
      className="btn btn-primary QueryWizardButton"
      style={{ paddingTop: "3px", paddingBottom: "3px" }}
      onClick={onClick}
    >
      Confirm selection...
    </button>
  </div>
);

@inject("detailViewStore", "cubeQueryWizardStore", "previewStore")
@observer
class TemplateRepresentation extends React.Component {
  tableContainerRef = React.createRef();
  fakeContainerRef = React.createRef();
  cellWidth = 200;

  tableWidth;

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      scrollLeft: 0,
      selectedCubeIndex: null,
      entityDataSnapshot: null,
    };
  }

  componentDidMount() {
    this.initFakeScroll();
    this.initializeSelectedCubeIndex();
  }

  componentDidUpdate(prevProps, prevState) {
    const { getEntityData } = this.context;
    if (
      getEntityData.item !== this.state.entityDataSnapshot &&
      getEntityData.item.object.type === "Cube"
    ) {
      this.setState({ entityDataSnapshot: getEntityData.item }, () => {
        this.initializeSelectedCubeIndex();
      });
    }
  }

  componentWillUnmount() {
    if (!this.tableContainerRef || !this.tableContainerRef.current) return;
    if (!this.fakeContainerRef || !this.fakeContainerRef.current) return;
    this.tableContainerRef.current.removeEventListener(
      "scroll",
      this.handleFakeScroll
    );
    this.fakeContainerRef.current.removeEventListener(
      "scroll",
      this.handleContainerScroll
    );
  }

  handleCollapse = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  initFakeScroll = () => {
    if (!this.tableContainerRef || !this.tableContainerRef.current) return;
    if (!this.fakeContainerRef || !this.fakeContainerRef.current) return;
    const fakeScrollElement =
      this.fakeContainerRef.current.querySelector("div");
    if (fakeScrollElement) {
      fakeScrollElement.style.width = `${this.tableWidth}px`;
    }
    this.fakeContainerRef.current.addEventListener(
      "scroll",
      this.handleFakeScroll
    );
    this.tableContainerRef.current.addEventListener(
      "scroll",
      this.handleContainerScroll
    );
  };

  handleFakeScroll = () => {
    this.setState(
      {
        scrollLeft: this.fakeContainerRef.current.scrollLeft,
      },
      () => {
        this.tableContainerRef.current.scrollLeft = this.state.scrollLeft;
      }
    );
  };

  handleContainerScroll = () => {
    this.setState(
      {
        scrollLeft: this.tableContainerRef.current.scrollLeft,
      },
      () => {
        this.fakeContainerRef.current.scrollLeft = this.state.scrollLeft;
      }
    );
  };

  handleConfirmSelection = () => {
    this.props.cubeQueryWizardStore.toggleTemplateRepresentationSelection(
      false
    );
    this.props.cubeQueryWizardStore.toggleShowQueryWizard(true, true);
  };

  setTableWidth = (width) => {
    this.tableWidth = width;
    if (this.tableWidth) {
      this.initFakeScroll();
    }
  };
  findCubeToTables = (data, acc) => {
    if (data.object.type === "CubeToTable") {
      acc.push(data);
    } else {
      if (data.items)
        for (let i = 0; i < data.items.length; i += 1) {
          const currentChild = data.items[i];
          this.findCubeToTables(currentChild, acc);
        }
    }
  };
  findItemById = (tree, nodeId) => {
    for (let node of tree) {
      if (node.object.tid.toString() === nodeId) return node;

      if (node.items) {
        let desiredNode = this.findItemById(node.items, nodeId);
        if (desiredNode) return desiredNode;
      }
    }
    return false;
  };

  dateRange = (currentVersion) => {
    return ` (${moment(currentVersion.validFrom).format(
      "DD.MM.YYYY"
    )} - ${moment(currentVersion.validTo).format("DD.MM.YYYY")})`;
  };

  initializeSelectedCubeIndex = () => {
    const { getEntityData } = this.context;
    const entityData = getEntityData.item;
    if (entityData && entityData.navigationLookupResult) {
      let cubeToTableItem =
        entityData.navigationLookupResult.navigationLookupRootItem.items?.filter(
          (item) => item.object.type === "CubeToTable"
        ) || [];
      const selectedIndex = this.getClosestValidToIndex(
        cubeToTableItem,
        entityData.object
      );
      this.setState({ selectedCubeIndex: selectedIndex });
    }
  };

  getClosestValidToIndex = (cubeToTableItem, entityObject) => {
    if (!cubeToTableItem || cubeToTableItem.length === 0) return 0;

    const entityValidTo = entityObject?.validTo
      ? new Date(entityObject.validTo).getTime()
      : new Date("9999-12-31").getTime();

    let closestIndex = 0;
    let minDiff = Infinity;

    cubeToTableItem.forEach((item, index) => {
      const itemValidTo = item?.items?.[0]?.object?.validTo
        ? new Date(item.items[0].object.validTo).getTime()
        : new Date("9999-12-31").getTime();
      if (!isNaN(itemValidTo)) {
        const diff = Math.abs(entityValidTo - itemValidTo);

        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = index;
        }
      }
    });

    return closestIndex;
  };

  static contextType = StoreContext;
  render() {
    const { visibleItems } = this.props;
    const { open, selectedCubeIndex } = this.state;
    const { fetchingDataStatus, getEntityData } = this.context;
    const entityData = getEntityData.item;
    const isFetching = fetchingDataStatus.get("Table") === true;
    const searchVisibleItems =
      visibleItems && visibleItems[0]
        ? visibleItems[0].substring(0, visibleItems[0]?.indexOf("-"))
        : null;
    let cubeToTableItem;
    if (searchVisibleItems) {
      let toSearch;
      toSearch = this.findItemById(
        entityData.navigationLookupResult.navigationLookupRootItem.items,
        searchVisibleItems
      );
      let results = [];
      if (toSearch) this.findCubeToTables(toSearch, results);
      cubeToTableItem = results;
      if (cubeToTableItem.length === 0)
        return (
          <div
            className="custom-panel-heading"
            style={{ marginBottom: "30px" }}
          >
            <h4>No data Available</h4>
          </div>
        );
    } else {
      if (
        (!entityData ||
          !entityData.navigationLookupResult ||
          !entityData.navigationLookupResult.navigationLookupRootItem ||
          !entityData.navigationLookupResult.navigationLookupRootItem.items ||
          !entityData.navigationLookupResult.navigationLookupRootItem.items
            .length) &&
        !isFetching
      ) {
        return null;
      }

      cubeToTableItem =
        entityData.navigationLookupResult.navigationLookupRootItem.items.filter(
          (item) => item.object.type === "CubeToTable"
        ) ?? { items: [] };
      if (
        (!cubeToTableItem || !cubeToTableItem.items) &&
        !isFetching &&
        !cubeToTableItem.length > 0
      )
        return null;
    }
    const hasTable =
      cubeToTableItem?.length ||
      (cubeToTableItem.items &&
        cubeToTableItem?.items.filter((item) => item.object.type === "Table")
          .length > 0);
    if (!hasTable && !isFetching) {
      return null;
    }
    if (cubeToTableItem.length > 0) {
      cubeToTableItem = [
        ...new Map(cubeToTableItem.map((v) => [v.object.tableId, v])).values(),
      ];
    }
    return (
      <div ref={this.props.innerRef} className="custom-panel">
        <div className="custom-panel-heading">
          <div style={{ display: "flex" }}>
            <h4>Template Representation</h4>
            {isFetching && (
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            )}
          </div>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              this.handleCollapse();
            }}
          >
            {!cubeToTableItem.length ? (open === true ? "hide" : "show") : null}
          </a>
        </div>

        {!isFetching && (
          <Collapse in={open}>
            <div className="custom-panel-body">
              <div id="template-fake-container" ref={this.fakeContainerRef}>
                <div id="template-fake-scroll"></div>
              </div>
              {this.props.cubeQueryWizardStore
                .isTemplateRepresentationSelectionOn && (
                <React.Fragment>
                  <ConfirmButton onClick={this.handleConfirmSelection} />
                </React.Fragment>
              )}
              <div
                className="item-list-container template-table-container"
                ref={this.tableContainerRef}
              >
                {cubeToTableItem.length && entityData.object.type !== "Cube" ? (
                  cubeToTableItem.map((item, index) => {
                    const tableObject =
                      Array.isArray(item.items) && item.items[0]
                        ? item.items[0].object
                        : null;

                    if (tableObject === null) {
                      return (
                          <div
                              className="custom-panel-heading"
                              style={{marginBottom: "30px"}}
                          >
                            <h4>No data Available</h4>
                          </div>
                      );
                    }
                    return (
                        <React.Fragment
                            key={`${tableObject?.tid ?? 'no-tid'}-${index}`}
                        >
                        <div
                          className="custom-panel"
                          style={{
                            marginBottom: "50px",
                            marginTop: "30px",
                            marginInline: "5px",
                            overflowX: "auto",
                          }}
                        >
                          <div
                            className="custom-panel-heading"
                            style={{ marginBottom: "30px" }}
                          >
                            <div>
                              <h4>
                                {tableObject?.name} ({tableObject?.code})
                              </h4>
                            </div>
                          </div>
                          <div
                            style={{
                              marginBottom: "20px",
                              marginInline: "10px",
                            }}
                          >
                            <PivotTable
                              cubeToTableItem={item}
                              itemIndex={index}
                              entityData={entityData}
                              setTableWidth={this.setTableWidth}
                              cubeQueryWizardStore={
                                this.props.cubeQueryWizardStore
                              }
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <>
                    {selectedCubeIndex !== null &&
                    cubeToTableItem.length &&
                    cubeToTableItem.length > 1 ? (
                      <div className="descriptive-metadata">
                        <p className=" versions">
                          <b>Table version:</b>{" "}
                          {!cubeToTableItem[selectedCubeIndex - 1] ? (
                            <span
                              className={`toggle ${
                                !cubeToTableItem[selectedCubeIndex - 1]
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <Glyphicon glyph="chevron-left" />
                            </span>
                          ) : (
                            <Link
                              onClick={(e) => {
                                this.setState({
                                  selectedCubeIndex: selectedCubeIndex - 1,
                                });
                              }}
                            >
                              <Glyphicon glyph="chevron-left" />
                            </Link>
                          )}
                          <span className="current-version">
                            {
                              cubeToTableItem[selectedCubeIndex]?.items[0]
                                ?.object?.version
                            }
                          </span>
                          {!cubeToTableItem[selectedCubeIndex + 1] ? (
                            <span
                              className={`toggle ${
                                !cubeToTableItem[selectedCubeIndex + 1]
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <Glyphicon glyph="chevron-right" />
                            </span>
                          ) : (
                            <Link
                              onClick={(e) => {
                                this.setState({
                                  selectedCubeIndex: selectedCubeIndex + 1,
                                });
                              }}
                            >
                              <Glyphicon glyph="chevron-right" />
                            </Link>
                          )}
                          <span className="current-version">
                            {this.dateRange(
                              cubeToTableItem[selectedCubeIndex]?.items[0]
                                ?.object
                            )}
                          </span>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className="custom-panel"
                      style={{
                        marginBottom: "50px",
                        marginTop: "30px",
                        marginInline: "5px",
                        overflowX: "auto",
                      }}
                    >
                      <div
                        className="custom-panel-heading"
                        style={{ marginBottom: "30px" }}
                      >
                        <div>
                          <h4>
                            {
                              cubeToTableItem[selectedCubeIndex]?.items[0]
                                ?.object?.name
                            }{" "}
                            (
                            {
                              cubeToTableItem[selectedCubeIndex]?.items[0]
                                ?.object?.code
                            }
                            )
                          </h4>
                        </div>
                      </div>
                      <PivotTable
                        cubeToTableItem={cubeToTableItem[selectedCubeIndex]}
                        itemIndex={0}
                        entityData={entityData}
                        setTableWidth={this.setTableWidth}
                      />
                    </div>
                  </>
                )}
              </div>
              {this.props.cubeQueryWizardStore
                .isTemplateRepresentationSelectionOn && (
                <ConfirmButton onClick={this.handleConfirmSelection} />
              )}
            </div>
          </Collapse>
        )}
      </div>
    );
  }
}

export default TemplateRepresentation;
